import { KindResultDecisionCodesEnum } from 'APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';
import { IPosition } from 'APIPackage/DictionariesModule/interfaces/IPosition';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';

export const getResultDecisionPositionsSelectOptions = (
  kindCode: string | undefined,
  participantPositionsSelectOptions: IDictionaryParticipantPositionSelectOption[] | undefined,
  positionsSelectOptions: IDictionarySelectOption<IPosition>[] | undefined,
): IDictionaryParticipantPositionSelectOption[] | undefined => {
  if (kindCode === KindResultDecisionCodesEnum.D_7) {
    const participantTitleKeys = new Set(
      participantPositionsSelectOptions?.map(p => p.title.toLocaleLowerCase().trim()) ?? [],
    );

    const mappedPositions: IDictionaryParticipantPositionSelectOption[] =
      positionsSelectOptions
        ?.filter(position => !participantTitleKeys.has(position.title.toLocaleLowerCase().trim()))
        .map(position => ({
          ...position,
          inspectionResult: undefined,
        })) ?? [];

    return [...(participantPositionsSelectOptions ?? []), ...mappedPositions].sort((a, b) =>
      a.title.localeCompare(b.title, 'ru', { sensitivity: 'base' }),
    );
  }

  return participantPositionsSelectOptions;
};
